import { AcademicContentCreate } from './AcademicContentCreate';
import { AcademicContentEdit } from './AcademicContentEdit';
import { AcademicContentList } from './AcademicContentList';

export default {
    create: AcademicContentCreate,
    edit: AcademicContentEdit,
    list: AcademicContentList
}
